import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { SecurityService } from '../services/security.service';

/**
 * Directive to conditionally display elements based on user permissions.
 */
@Directive({
  selector: '[ifPermission]',
  standalone: false,
})
export class IfPermissionDirective implements OnInit {
  @Input('ifPermission') permission: string;

  isFetchingPermission = false;

  constructor(private securityService: SecurityService, private viewContainer: ViewContainerRef, private templateRef: TemplateRef<any>) {}

  ngOnInit() {
    if (this.securityService.hasPermission(this.permission)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}

export enum Permission {
  DeleteInspectionCompanyUser = '10c6509a-8020-4ec0-bc56-5fe377880e6a',
  EditInspectionCompanyDetails = '93e441f4-bd5a-497a-8aa5-48e0f44884ab',
  InviteSubcontractor = '0b74d433-319e-4333-b0fd-eef8e05449ac',
  InviteUsersToInspectionCompany = '1f6c6a60-989b-461e-a76e-20bf737654f4',
  UpdateInspectionCompanyCommunications = '01ef80ed-7c9f-42dc-8262-aaf0a3533025',
  UpdateInspectionCompanyUsers = '271cee4a-7e58-4e4f-a4d8-b78fe2903adc',
  ReadNotifications = '2e6ca540-0efa-4670-82f2-6cdcbe264bf3',
  CreateNotifications = '775dae0d-7de6-4df8-8f15-7e3db3afbdee',
  UpdateNotifications = '763459aa-930e-4f3d-8d1e-5b681c207036', // update or publish
  DeleteNotifications = 'ff78b95e-590f-4e0a-89b9-90cafbb6a00a',
}
